import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user-status12",
  "use": "icon-user-status12-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-user-status12\">\n<g id=\"icon-user-status12_icon\" clip-path=\"url(#icon-user-status12_clip0_677_42883)\">\n<path id=\"icon-user-status12_Vector\" d=\"M7.99987 0.964844C4.11427 0.964844 0.964355 4.11461 0.964355 8.00007C0.964355 11.8855 4.11427 15.0353 7.99987 15.0353C11.8855 15.0353 15.0354 11.8855 15.0354 8.00007C15.0354 4.11461 11.8855 0.964844 7.99987 0.964844ZM7.51027 10.503L6.50408 11.5087L5.49734 10.503L3.4844 8.48993L4.49061 7.48378L6.50371 9.49608L11.5088 4.49141L12.5154 5.49756L7.51027 10.503Z\" fill=\"#84BF40\" />\n</g>\n<defs>\n<clipPath id=\"icon-user-status12_clip0_677_42883\">\n<rect width=\"16\" height=\"16\" fill=\"white\" />\n</clipPath>\n</defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/user-status12.svg
// module id = uef2
// module chunks = 102